import {
  CreateVisitResponseDto,
  UpdateVisitResponseDto,
  VisitCreationRequestDto,
  VisitUpdateRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const visitsRequests = {
  createVisit: EndpointDefinition.post<
    CreateVisitResponseDto,
    VisitCreationRequestDto,
    null
  >({
    name: 'createVisit',
    route: '/visits',
  }),

  updateVisit: EndpointDefinition.patch<
    UpdateVisitResponseDto,
    VisitUpdateRequestDto,
    { visitId: number }
  >({
    name: 'updateVisit',
    route: '/visits/:visitId',
  }),

  deleteVisit: EndpointDefinition.delete<null, { visitId: number }>({
    name: 'deleteVisit',
    route: '/visits/:visitId',
  }),
};
